import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function BillingCancelledPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F8FAFB] flex items-center justify-center px-4" data-testid="billing-cancelled-page">
      <div className="max-w-md text-center">
        <XCircle className="h-12 w-12 text-[#B0BEC5] mx-auto mb-4" />
        <h1 className="text-xl font-bold text-[#0A2533] mb-2">Checkout cancelled</h1>
        <p className="text-sm text-[#4E6974] mb-6">No charges were made. You can subscribe at any time.</p>
        <button onClick={() => navigate('/billing')} data-testid="billing-cancelled-back-btn"
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-[#00707C] hover:bg-[#005F6A] text-white text-sm font-medium rounded-lg transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to billing
        </button>
      </div>
    </div>
  );
}
